import * as React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  SafeAreaView,
} from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import DisclaimerText from "../../../commonComponents/DisclaimerText";
import Header from "../../../commonComponents/Header";
import { useEffect } from "react";
import { isMobile, trackMoengageEvent } from "../../../utils/commonMethods";
import { globalImport } from "../../../common/globalImports";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import { Icon } from '@iconify/react';

const WalletTxnStatus = ({
  navigation,
  route,
  paymentStatus1: paymentRes,
  setStatus,
}) => {
  const paymentStatus = route?.params?.paymentStatus || paymentRes;
  const error = !paymentStatus?.status;
  const isDeposit = paymentStatus?.isDeposit;
  const disclaimer = paymentStatus?.disclaimer ?? null;
  const amount = paymentStatus?.amount;
  const isCryptoWithdrawal = paymentStatus?.isCrypto;
  const region = paymentStatus?.region || 'INDIA';
  const currency = paymentStatus?.currency || (region !== 'INDIA' && isCryptoWithdrawal ? 'USDT' : 'Credits');
  const title = paymentStatus?.title || (error ? "Withdraw Failed" : "Withdraw Processing");
  const msg = paymentStatus?.msg;
  const buttonText = paymentStatus?.buttonText || "Done";
  const blocked = paymentStatus?.blocked;
  const paymentIsInProgress = paymentStatus?.paymentIsInProgress;
  const isDesktop = !isMobile();

  useEffect(() => {
    if (isDeposit) {
      trackMoengageEvent("add button clicked", {
        displayedPopup: error ? "Failed" : "Success",
      });
    }
  }, []);

  const onDoneClick = async () => {
    if (
      paymentStatus?.profileVerified !== undefined &&
      !paymentStatus?.profileVerified
    ) {
      !isDesktop && navigation.pop(2);
      navigation.navigate("Profile");
    } else if (!error) {
      if (!isDesktop) {
        navigation.pop(2);
      } else {
        setStatus(null);
      }
    } else {
      if (!isDesktop) {
        navigation.pop();
      } else {
        setStatus(null);
      }
    }
  };

  const getStatusIcon = () => {
    if (error) {
      return (
        <Icon
          icon="solar:close-circle-bold"
          width={80}
          height={80}
          color="#A8200D"
        />
      );
    }
    if (paymentIsInProgress) {
      return (
        <Icon
          icon="solar:clock-circle-bold"
          width={80}
          height={80}
          color="#E8B600"
        />
      );
    }
    return (
      <Icon
        icon="solar:check-circle-bold"
        width={80}
        height={80}
        color="#00AA51"
      />
    );
  };

  return (
    <View style={{ backgroundColor: Colors.bgWhite, flex: 1, height: '100%' }}>
      {!isDesktop && (
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={null}
          popTO={
            paymentStatus?.profileVerified !== undefined &&
            !paymentStatus?.profileVerified
              ? 2
              : 1
          }
        />
      )}
      <View style={styles.statusBlock}>
        <View style={styles.iconContainer}>
          {getStatusIcon()}
        </View>

        <View style={styles.contentContainer}>
          <FormTextLabel
            label={title}
            labelStyles={styles.titleText}
          />

          <FormTextLabel
            label={msg}
            labelStyles={styles.messageText}
          />
        </View>

        {disclaimer !== null && (
          <View style={styles.disclaimerContainer}>
            <DisclaimerText text={disclaimer} />
          </View>
        )}
      </View>

      <View style={[globalStyle.bottomAbsBtnBar, { 
        left: 0, 
        right: 0,
        paddingHorizontal: 16,
        paddingBottom: isDesktop ? 16 : 16,
        backgroundColor: Colors.bgWhite,
        width: '100%',
      }]}>
        <Button
          translate={true}
          variant="primary"
          onPress={() => {
            setTimeout(() => {
              onDoneClick();
            }, globalConst.buttonTimer);
          }}
          style={{width: '100%'}}
          size="large"
        >
          {buttonText}
        </Button>
      </View>
    </View>
  );
};

export default WalletTxnStatus;

const styles = StyleSheet.create({
  statusBlock: {
    flex: 1,
    paddingHorizontal: 24,
    alignItems: "center",
    justifyContent: "center",
    marginTop: isMobile() ? -80 : 0,
    minHeight: isMobile() ? 'auto' : '60vh',
    display: 'flex',
  },
  iconContainer: {
    marginBottom: 32,
    alignItems: "center",
  },
  contentContainer: {
    alignItems: "center",
    maxWidth: 320,
    width: '100%',
  },
  titleText: {
    ...globalFontStyle.appFontTitle,
    color: globalConfigurableData.primaryTextColor1,
    textAlign: "center",
    marginBottom: 16,
    fontSize: 20,
    lineHeight: 28,
    fontWeight: '600',
  },
  messageText: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
    textAlign: "center",
    marginBottom: 0,
    lineHeight: 20,
    fontSize: 14,
  },
  disclaimerContainer: {
    marginTop: 32,
    width: "100%",
    maxWidth: 320,
    backgroundColor: "rgba(0, 0, 0, 0.03)",
    borderRadius: 8,
    padding: 16,
  }
});
